import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsStagesPlanWorksProducts(companyId, regulationId, stageId, planWorkId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].getRegulationsStagesPlanWorksProducts,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksProductPreview(companyId, regulationId, stageId, planWorkId, productId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].getRegulationsStagesPlanWorksProductPreview,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				productId,
			},
		},
	)
}
function getRegulationsStagesPlanWorksProductPopup(companyId, regulationId, stageId, planWorkId, productId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].getRegulationsStagesPlanWorksProductPopup,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
				stageId,
				planWorkId,
				productId,
			},
		},
	)
}

function createRegulationsStagesPlanWorksProduct(companyId, regulationId, stageId, planWorkId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].createRegulationsStagesPlanWorksProduct, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
		},
		...data,
	})
}

function getRegulationsStagesPlanWorksProduct(companyId, regulationId, stageId, planWorkId, productId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].getRegulationsStagesPlanWorksProduct, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			productId,
		},
	})
}

function patchRegulationsStagesPlanWorksProduct(companyId, regulationId, stageId, planWorkId, productId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].patchRegulationsStagesPlanWorksProduct, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			productId,
		},
		...data,
	})
}

function putRegulationsStagesPlanWorksProduct(companyId, regulationId, stageId, planWorkId, productId, data) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].putRegulationsStagesPlanWorksProduct, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			productId,
		},
		...data,
	})
}

function deleteRegulationsStagesPlanWorksProduct(companyId, regulationId, stageId, planWorkId, productId) {
	return dataTransferWrap(ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS,dtConfig[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS].deleteRegulationsStagesPlanWorksProduct, {
		urlParams: {
			companyId,
			regulationId,
			stageId,
			planWorkId,
			productId,
		},
	})
}

export default {
	getRegulationsStagesPlanWorksProducts,
	getRegulationsStagesPlanWorksProductPopup,
	getRegulationsStagesPlanWorksProductPreview,
	getRegulationsStagesPlanWorksProduct,
	patchRegulationsStagesPlanWorksProduct,
	putRegulationsStagesPlanWorksProduct,
	createRegulationsStagesPlanWorksProduct,
	deleteRegulationsStagesPlanWorksProduct,
}
